import { site } from '@/mocks/site';

export default function CtaStrip() {
  return (
    <section className="mx-auto max-w-7xl px-4 pb-12 md:px-6">
      <div className="relative overflow-hidden rounded-[2rem] bg-gradient-to-r from-primary-500 via-primary-400 to-accent-400 px-6 py-10 text-cream-50 md:px-12 md:py-14">
        <div className="pointer-events-none absolute -right-10 -top-10 h-48 w-48 rounded-full bg-cream-50/20" />
        <div className="pointer-events-none absolute -bottom-12 right-40 h-40 w-40 rounded-full bg-cream-50/10" />
        <div className="relative flex flex-col items-start justify-between gap-6 lg:flex-row lg:items-center">
          <div className="max-w-xl">
            <h2 className="font-display text-2xl leading-snug md:text-3xl">
              你身边也有值得上热搜的名场面吗？
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-cream-100 md:text-base">
              无论是班长学委的神操作、社团的高光时刻，还是反差到让人惊呼的同学，都可以把素材发给编辑部。
              我们会用匿名、不泄露隐私的方式整理成文，让更多同学一起快乐吃瓜。
            </p>
          </div>
          <a
            href={`mailto:${site.email}`}
            className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-full bg-cream-50 px-7 py-3.5 text-sm font-bold text-primary-700 transition-transform hover:scale-105"
          >
            <i className="ri-send-plane-line text-lg" />
            我要投稿
          </a>
        </div>
      </div>
    </section>
  );
}